<app-spinner-button (click)="downloadKeystore()" [options]="keystoreBtn">
  Download keystore
</app-spinner-button>
